import { useMemo } from 'react';

import { useSubscriptionStore } from '@/_app/providers/SubscriptionLockScreenProvider/useSubscriptionStore';
import { useApolloClient } from '@/shared/services/apollo';
import { useAuthStore } from '@/shared/store/auth.store';

import { GraphQLLoader } from '../loaders/graphql-loader';

export function useGqlLoader(): GraphQLLoader {
  const apolloClient = useApolloClient();
  const setIsSubscriptionActive = useSubscriptionStore((s) => s.setIsSubscriptionActive);
  const { legacyToken } = useAuthStore();

  return useMemo(
    () =>
      new GraphQLLoader(apolloClient, () =>
        setIsSubscriptionActive({ isActive: false, isRegistered: true }),
      ),
    [apolloClient, legacyToken],
  );
}
